import Fetcher from "../../../Common/Fetch";

export function GetLotInfoPromise(lotId: Number) {
    console.log('GetDataByOpenAuctionWithApplications lotId=', lotId);
    return Fetcher("/TradeLotApi/GetDataByOpenAuctionWithApplications?lotId=" + lotId.toString(), {
        method: 'GET', headers: { 'Content-Type': 'application/json' }
    })
        .then(res => res.json());
}